import React from "react"
import { useTranslation } from "react-i18next"
import { formatVars } from "../../helpers/translation"
import { formatFileSize } from "../../helpers/formatfilesizefilter.coffee"

const FilesAndSizeDisplay = ({ className, fileCount, fileSize }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation("generic")

  const formatter = (msgSrc, placeholderValues) =>
    formatVars(language, msgSrc, placeholderValues)

  return (
    <span className={className}>
      {formatVars(language, t("##.Upload.CurrentFilesAndSize"), {
        FILE_COUNT: fileCount,
        SIZE: formatFileSize(t, formatter)(fileSize),
      })}
    </span>
  )
}

export default FilesAndSizeDisplay
